export const PREVIEW_PLACEHOLDER_QUERY_PARAM = 'placeholders';

export const EMPTY_CONTENT_BLOCK_IMAGE = '#';

export const CONTENT_BACKGROUND_COLORS = ['white', 'grey', 'stone'] as const;

export const PADDING_SIZES = ['none', 'small', 'medium', 'large'] as const;

export const HEADLINE_SIZES = ['2', '3'] as const;

export const IMAGE_POSITIONS = ['left', 'right'] as const;

export const ITEM_FLIP_STATES = ['default', 'flip'] as const;

export const FREE_SHOPIFY_PRODUCT_IDENTIFIERS = ['Welcome Gift', 'Welcome Kit'];
